import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '@components/loader/loader.component';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  id = input.required<string>();
  btnLabel = input<string>();
  startIcon = input<{ src: string; alt: string }>();
  endIcon = input<{ src: string; alt: string }>();
  btnClasses = input<string>();
  disabled = input<boolean>(false);
  backgroundColor = input<string>();
  color = input<string>();
  border = input<string>();
  width = input<string>();
  isLoading = input<boolean>(false);
  height = input<string>();
}
